import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { getEscalatorBaseUrl } from '@atlassian/jira-servicedesk-incident-management-common/src/utils';
import type { CloudId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { ConfluencePageResult, ConfluenceSpaceResult } from './types';

export const fetchConfluenceSpace = async (
	searchText: string,
	cloudId: CloudId,
): Promise<ConfluenceSpaceResult[]> => {
	const response: ConfluenceSpaceResult[] = await fetchJson(
		`${getEscalatorBaseUrl(cloudId)}/confluence/space/search?searchPhrase=${searchText ?? ''}`,
	);
	return response;
};

export const fetchConfluencePage = async (
	confluenceSpaceId: string,
	cloudId: CloudId,
	query: string,
): Promise<ConfluencePageResult[]> => {
	const response: ConfluencePageResult[] = await fetchJson(
		`${getEscalatorBaseUrl(cloudId)}/confluence/page/search?spaceKey=${
			confluenceSpaceId ?? ''
		}&searchPhrase=${query ?? ''}`,
	);
	return response;
};
